export default "__VITE_ASSET__7I98QOS2__"